
export default class AreaCategoryFilterBlock {
	static init() {
        const preselectedCategoryFromUri = (window.location.hash && window.location.hash.startsWith('#filter-')) ? window.location.hash.replace('#filter-', '') : null
        const preselectedCategoryElement = preselectedCategoryFromUri ? document.querySelector(`.area-category-filter-block--inline-filter .filter-tag[data-category*="${preselectedCategoryFromUri}"]`) : null
        if (preselectedCategoryElement) {
            AreaCategoryFilterBlock.updateCategories(preselectedCategoryElement)
            AreaCategoryFilterBlock.filterList()
        }

		window.addEventListener('click', (e) => {
			const tag = e.target.closest('.area-category-filter-block--inline-filter .filter-tag');
			if (tag) {
				e.preventDefault();
                AreaCategoryFilterBlock.updateCategories(tag);
                AreaCategoryFilterBlock.updateLocationHash(tag);
                AreaCategoryFilterBlock.filterList();
			}
		});

        document.querySelectorAll('.area-category-filter-block .filter-tag').forEach(el => {
            let category = el.dataset.category;
            if (category === 'all') {
                return;
            }

            if (document.querySelectorAll(`[data-filter*=${category}]`).length === 0) {
                el.classList.add('hide')
            }
        })
	}

    static updateCategories(newActiveElement) {
        let filterCatItem = document.querySelectorAll('.area-category-filter-block .filter-tag');
        filterCatItem.forEach(link => {
            link.classList.remove('active');
        });
        newActiveElement.classList.add('active');
    }

    static updateLocationHash(newActiveElement) {
        const location = window.location.href.replace(window.location.hash, '')
        let newHash = ''
        if (newActiveElement && newActiveElement.dataset.category !== 'all') {
            newHash = `#filter-${newActiveElement.dataset.category}`
        }
        window.history.pushState({}, "", location + newHash)
    }

	static filterList() {
		let selectedFilter = document.querySelector('.area-category-filter-block .filter-tag.active').getAttribute('data-category');
		let itemsToHide = Array.from(document.querySelectorAll(`.category-filter li:not([data-filter*='${selectedFilter}'])`));
		let itemsToShow = Array.from(document.querySelectorAll(`.category-filter [data-filter*='${selectedFilter}']`));

		if (selectedFilter === 'all') {
			itemsToHide = [];
			itemsToShow = document.querySelectorAll('.category-filter [data-filter]');
		}

		itemsToHide.forEach(el => {
			el.classList.add('hide');
			el.classList.remove('show');
		});

        itemsToShow.forEach(el => {
            el.classList.remove('hide');
            el.classList.add('show');
		});

        // if a whole category is empty, hide it
        Array.from(document.querySelectorAll('.area-filter-block__letter')).forEach(el => {
            let hasVisibleItem = el.querySelector('.category-filter [data-filter]:not(.hide)');
            el.classList[hasVisibleItem ? 'remove' : 'add']('hide');
        });
	}
}
